import React, { memo } from 'react';
import classNames from 'classnames';
import * as styles from '../../DataExtractionTemplate.module.scss';
import * as outcomeStyles from './OutcomesPanel.module.scss';
import ConsolidatedMeasures from './ConsolidatedMeasures/ConsolidatedMeasures';
import OutcomeDetails from './OutcomeDetails/OutcomeDetails';
import OutcomePopoverText from './OutcomePopoverText';
import OutcomesList from './OutcomesList/OutcomesList';
import { useOutcomeWizardContext } from './OutcomeWizardProvider';
import { Heading } from 'components/core';
import { useReviewFeaturesContext } from 'contexts/ReviewFeaturesProvider';

type Props = {
  resultsDataAnchor?: string;
};
const OutcomesPanel = ({ resultsDataAnchor }: Props) => {
  const wizard = useOutcomeWizardContext();
  const { hasSelectableMeasures } = useReviewFeaturesContext();
  const sectionClassnames = classNames({
    [styles.Panel]: true,
    [styles.WithinAccordion]: true,
  });

  return (
    <section className={sectionClassnames}>
      {!wizard.isWizardOpen && (
        <>
          <div className={outcomeStyles.outcomeDetailsSection}>
            <Heading type="h5" component="h4" variant="neutral">
              Outcomes
            </Heading>
            <OutcomePopoverText weak />
            <OutcomesList resultsDataAnchor={resultsDataAnchor} />
          </div>
          <OutcomeDetails showHeading />
        </>
      )}
      {!wizard.isWizardOpen && hasSelectableMeasures && (
        <ConsolidatedMeasures showHeader />
      )}
    </section>
  );
};

export default memo(OutcomesPanel);
